import { FC } from "react";

type Props = {
  title: string;
  value: string | number | null | undefined;
};

export const InfoRow: FC<Props> = ({ title, value }) => {
  return (
    <div className="grid grid-cols-2 mb-4 pb-4 border-b border-alpha-40 last-of-type:border-b-0 last-of-type:pb-0 last-of-type:mb-0">
      <p className="text-sm font-medium text-content-300">{title}</p>
      <p className="text-sm font-medium text-content-1000">{value || "--"}</p>
    </div>
  );
};
